import React from "react";
import { FaFacebookF, FaYoutube } from "react-icons/fa";

const SocialLinks = (props) => (
  <>
    <a
      href="https://www.facebook.com/ipumc/"
      target="_blank"
      rel="noreferrer"
      aria-label="Irving Park United Methodist Church Facebook"
    >
      <FaFacebookF />
    </a>
    <a
      href="http://www.youtube.com/@IrvingParkChurch"
      target="_blank"
      rel="noreferrer"
      aria-label="Irving Park United Methodist Church YouTube"
    >
      <FaYoutube />
    </a>
  </>
);

export default SocialLinks;
